require('dotenv').config();
/* eslint-disable max-len */


module.exports = {
  // default locale is the first one
  locales: [
    /* @intl-code-template '${lang}-${COUNTRY}', */
    'en-US',
    'es',
    'fr-FR',
    'id-ID',
    'ja-JA',
    'ru-RU',
    'ar'
    /* @intl-code-template-end */
  ],

  // Node.js app
  port: process.env.PORT,

  // https://expressjs.com/en/guide/behind-proxies.html
  trustProxy: process.env.TRUST_PROXY || 'loopback',

//Order alert tone upload
toneUploadDir: process.env.TONE_UPLOAD_DIR || '/images/tone/',

  // SITE URL
  siteUrl: 'https://www.eazyeat.sarl',

  // API Gateway
  api: {
    // API URL to be used in the client-side code
    clientUrl: process.env.API_CLIENT_URL || '',
    // API URL to be used in the server-side code
    serverUrl:
      process.env.API_SERVER_URL ||
      `http://localhost:${process.env.PORT || 3000}`,

    apiEndpoint: process.env.API_ENDPOINT_URL || 'https://www.eazyeat.sarl/api'
  },

  //Socket URL
  socketUrl: process.env.SOCKET_URL || 'https://www.eazyeat.sarl',

  distance: process.env.DISTANCE,

  // Database
  databaseUrl: process.env.DATABASE_URL,

  // Maximum upload size
  maxUploadSize: process.env.MAX_UPLOAD_SIZE || 50,

  // CRONs Timezone
  cronTimezone: process.env.CRON_TIMEZONE,
  // Refer this link for valid timezone https://raw.githubusercontent.com/node-cron/tz-offset/master/generated/offsets.json

    licenseuploadDir: '/images/license/', // Licence Upload

  vehicleUploadDir: '/images/vehicle/',  // Vehicle Upload

  profilePhotouploadDir: '/images/avatar/', // Profile photo upload

  categoryUploadDir: '/images/category/', // category photo upload

  logoUploadDir: '/images/logo/', // Logo photo upload

  ogImageUploadDir: '/images/og-image/', // OG Image Upload

  homepageUploadDir: '/images/homepage/', // Home page photo upload

  staticpageUploadDir: '/images/staticpage/', // Static page photo upload

  deliveryVehicleUploadDir: '/images/delivery-vehicle/', // Delivery Vehicle Upload

  contentPageUploadDir: '/images/contentpage/', // Contentpage photo upload

  restaurantImageUploadDir: '/images/restaurant-image/', // RestaurantImage photo upload

  restaurantDocumentUploadDir: '/images/restaurant-document/', // RestaurantImage photo upload

  partnerHomepageUploadDir: '/images/partner-homepage/', // Partner Home page Image photo upload

  itemImageUploadDir: '/images/restaurant-itemImage/', // Restaurant Item Image

  faviconUploadDir: '/images/favicon/', // Favicon upload

  toneUploadDir: '/images/tone/', // Order alert tone upload

 

  // Push Notification Server Key
  serverKey: process.env.PUSH_NOTIFICATION_SERVER_KEY,

  //Google map api key
  googleMapAPI: process.env.GOOGLE_MAP_API || 'AIzaSyD2cVn4go3pmaOebKFo_fnvEitX-U9IB0k', //'AIzaSyA2kAjC5jtL31zBlTP8texW2qrETg3ATtA',

  // Web analytics
  analytics: {
    // https://analytics.google.com/
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },

  // Payment - Stripe
  payment: { /* From ENV */
    stripe: {
      secretKey: process.env.STRIPE_SECRET
    }
  },

  //twilio sms credential
  sms: {
    twilio: {
      accountSid: process.env.TWILIO_ACCOUNT_SID,
      authToken: process.env.TWILIO_AUTHTOKEN,
      phoneNumber: process.env.TWILIO_PHONE_NUMBER
    }
  },

  // Authentication
  auth: {
    jwt: { secret: process.env.JWT_SECRET },

    // https://developers.facebook.com/
    facebook: {
      id: process.env.FACEBOOK_APP_ID,
      secret:
        process.env.FACEBOOK_APP_SECRET,
    },

    // https://cloud.google.com/console/project
    google: {
      id:
        process.env.GOOGLE_CLIENT_ID,
      secret: process.env.GOOGLE_CLIENT_SECRET
    },

    // https://apps.twitter.com/
    twitter: {
      key: process.env.TWITTER_CONSUMER_KEY,
      secret:
        process.env.TWITTER_CONSUMER_SECRET,
    },
  },

  // Email Configuration
  emailConfig: {
    host: process.env.SMTP_HOST, /* From ENV */
    port: process.env.SMTP_PORT,
    email: process.env.SMTP_LOGIN_EMAIL,
    sender: process.env.SMTP_FROM_NAME,
    senderEmail: process.env.SMTP_SENDER_EMAIL,
    password: process.env.SMTP_LOGIN_PASSWORD,
    secure: process.env.SMTP_SECURE,
    tls: process.env.SMTP_TLS
  },

 placeDetailURL: 'https://places.googleapis.com/v1/places/',
  autoCompleteURL: 'https://places.googleapis.com/v1/places:autocomplete',
};
